import React from 'react'

import FlatButton from 'material-ui/FlatButton'
import LeftArrow from 'material-ui/svg-icons/hardware/keyboard-arrow-left'
import RightArrow from 'material-ui/svg-icons/hardware/keyboard-arrow-right'

export default class DateArrow extends React.Component {

  static Direction = {
    LEFT: 0,
    RIGHT: 1
  }

  constructor(props) {
    super(props)
    this.state = {
      direction: props.direction
    }
  }

  getArrowIcon() {
    switch (this.state.direction) {
      case DateArrow.Direction.LEFT:
        return <LeftArrow style={{ color: '#4d6f7f' }} />
      case DateArrow.Direction.RIGHT:
        return <RightArrow style={{ color: '#4d6f7f' }} />
      default:
        return null
    }
  }

  render() {
    return (
      <FlatButton
        style={{ minWidth: 32, height: 32 }}
        onTouchTap={this.props.onPress}>
        <div style={{ margin: 4 }}>
          { this.getArrowIcon() }
        </div>
      </FlatButton>
    )
  }

}



// WEBPACK FOOTER //
// ./src/common/date/DateArrow.js